// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DatasetFromLizardRaster
 */
export interface DatasetFromLizardRaster {
  /**
   *
   */
  lizardRasterUuid: string;
  /**
   *
   */
  topicCategories: Array<string>;
}

/**
 * Check if a given object implements the DatasetFromLizardRaster interface.
 */
export function instanceOfDatasetFromLizardRaster(value: object): value is DatasetFromLizardRaster {
  if (
    (!("lizardRasterUuid" in (value as Record<string, any>)) &&
      !("lizard_raster_uuid" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["lizardRasterUuid"] === undefined &&
      (value as Record<string, any>)["lizard_raster_uuid"] === undefined)
  )
    return false;
  if (
    (!("topicCategories" in (value as Record<string, any>)) &&
      !("topic_categories" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["topicCategories"] === undefined &&
      (value as Record<string, any>)["topic_categories"] === undefined)
  )
    return false;
  return true;
}

export function DatasetFromLizardRasterFromJSON(json: any): DatasetFromLizardRaster {
  return DatasetFromLizardRasterFromJSONTyped(json, false);
}

export function DatasetFromLizardRasterFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DatasetFromLizardRaster {
  if (json == null) {
    return json;
  }
  return {
    lizardRasterUuid: json["lizard_raster_uuid"],
    topicCategories: json["topic_categories"],
  };
}

export function DatasetFromLizardRasterToJSON(json: any): DatasetFromLizardRaster {
  return DatasetFromLizardRasterToJSONTyped(json, false);
}

export function DatasetFromLizardRasterToJSONTyped(
  value?: DatasetFromLizardRaster | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    lizard_raster_uuid: value["lizardRasterUuid"],
    topic_categories: value["topicCategories"],
  };
}
